export enum EmoteButton {
    none,

    // NMS 
    atlas,
    sClass,
    aClass,
    bClass,
    cClass,
    corruptedDrone,
    expPatchNull,
    expPatchUnderwater,
    expPatchUnits,
    goldenGek,
    ok,
    pioneerBadge,
    pioneerTrophy,
    seanMindBlown,
    seanHead,
    thumbsUp,
    units,
    nanites,
    waveAnomaly,
    wonder,

    // Satisfactory
    ficsit,
    ficsitThumbsUp,
    ficsitHead,
    ficsitCoupon,

    // Eddison
    eddisonLol,
    eddisonSir,
    eddisonLifeJacket,
    eddisonOnCouch,

    // Other
    amongUs,
    amongUsDance,
    bro,
    bunnyheart,
    facepalm,
    fakeNews,
    hype,
    kittyGun,
    pikaWhat,
    pressF,
    programming,
    report,
    yay,
    stonks,
    catHands,
    cool,
    coolThinking,
    no,
    yes,
    dancingHamster,
    dancingPanda,
}
